// extracted by mini-css-extract-plugin
export default {"urlBase":"urlBase__J23P9k"};